/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  ActivePathChangedActionPayload,
  SetQueryParamsActionPayload,
  SetParamsActionPayload,
  NavigateActionPayload,
} from 'src/app/features/shared/models/event/router-data-store';

/* action types */
export enum ActionTypes {
  ActivePathChanged = '[ROUTER] ActivePathChanged',
  SetQueryParams = '[ROUTER] SetQueryParams',
  SetParams = '[ROUTER] SetParams',
  Navigate = '[ROUTER] Navigate',
}

/* actions */

export const ActivePathChanged = createAction(
  ActionTypes.ActivePathChanged,
  props<{ payload: ActivePathChangedActionPayload }>(),
);

export const SetQueryParams = createAction(
  ActionTypes.SetQueryParams,
  props<{ payload: SetQueryParamsActionPayload }>(),
);

/* This event is fired when the user is navigates a page */
export const SetParams = createAction(
  ActionTypes.SetParams,
  props<{ payload: SetParamsActionPayload }>(),
);

/* This event is fired when the user is navigates a page */
export const Navigate = createAction(
  ActionTypes.Navigate,
  props<{ payload: NavigateActionPayload }>(),
);
